import SeoMeta from "@/components/feature/SeoMeta";
import TickerBar from "@/pages/home/components/TickerBar";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestSection from "@/pages/home/components/LatestSection";
import TopicSection from "@/pages/home/components/TopicSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { faqs } from "@/mocks/faqs";
import { siteInfo } from "@/mocks/site";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: "/",
      description: siteInfo.shortDesc,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "/topic/shoufa?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      description: siteInfo.intro,
      email: siteInfo.email,
      foundingDate: siteInfo.since,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.a,
        },
      })),
    },
  ];

  return (
    <>
      <SeoMeta
        title="独家大瓜 - 最新首发追踪 | 每日劲爆内幕持续更新"
        description="独家大瓜专注独家大瓜最新爆料与首发追踪，每日更新娱乐圈、网红圈劲爆内幕。从蛛丝马迹到实锤落地，持续跟进事件发酵全过程，实时更新首发线索与追踪时间线。"
        keywords="独家大瓜,独家大瓜最新,独家大瓜首发,大瓜爆料,劲爆内幕"
        path="/"
        jsonLd={jsonLd}
      />

      <TickerBar />
      <HeroSection />
      <LatestSection />
      <TopicSection />
      <TimelineSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}